import { Box, Icon, Text, dimensions } from '@factorialco/deprecated-design-system'
import type { ActivityLogsQuery } from 'generated/resources/graphql'
import moment from 'moment'

import { EmptyState } from 'modules/core/components/ActivityLog/Log/EmptyState'

type ActivityLogLog =
  ActivityLogsQuery['activityLog']['logsConnection']['nodes'][number]
import { Item } from 'modules/core/components/ActivityLog/Log/Item'
import i18n from 'modules/core/lib/i18n'

interface Props {
  upgradeElement?: React.ReactNode
  logs: ActivityLogLog[]
}

type LogsByDay = {
  [key: string]: ActivityLogLog[]
}

export const Timeline = ({ logs, upgradeElement }: Props) => {
  const logsByDate = logs.reduce<LogsByDay>((acc, log) => {
    const date = new Date(log.logDate)
    const key = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    if (!acc[key]) {
      acc[key] = []
    }

    acc[key]?.push(log)

    return acc
  }, {})

  if (!upgradeElement && Object.keys(logsByDate).length === 0) return <EmptyState />

  return (
    <Box flexDirection="row" width="full" paddingTop="s16">
      <Box
        background="grey300"
        style={{ width: '2px', marginLeft: dimensions.s24, marginTop: dimensions.s16 }}
      />
      {Object.keys(logsByDate).length > 0 && (
        <Box width="full">
          {Object.entries(logsByDate).map(([date, logValues]) => {
            const dateFormatted = moment(date).format('dddd, LL')

            const today = moment(date).isSame(moment(), 'day')

            return (
              <>
                <Box flexDirection="row" alignItems="center">
                  <Box
                    style={{ marginLeft: `calc(-${dimensions.s6} - ${dimensions.s1})` }}
                    paddingY="s12"
                  >
                    <Icon.Tiny icon="circle" color="grey800" />
                  </Box>
                  <Box paddingLeft="s16" data-testid="log-date">
                    <Text.Normal size="200" color="grey800" weight="medium">
                      {today ? i18n.t('common.today') : dateFormatted}
                    </Text.Normal>
                  </Box>
                </Box>
                <>
                  {(upgradeElement ? [logValues.at(0)] : logValues)?.map((log, index) => (
                    <> {log && <Item key={index} log={log} />} </>
                  ))}
                </>
              </>
            )
          })}
        </Box>
      )}
      {upgradeElement && upgradeElement}
    </Box>
  )
}
